import {
  Container, makeStyles, Typography, Grid
} from '@material-ui/core';
import React from 'react';
import LogoTreadMeal from 'src/components/LogoTreadMeal';
import colors from 'src/common/colors';

const useStyles = makeStyles(() => ({
  wrapper: {
    minHeight: '60vh',
    padding: 30,
    backgroundColor: colors.skin,
  },
  contentWrapper: {
    backgroundColor: '#fff',
    borderRadius: 15,
    paddingTop: 250,
    paddingBottom: 250,
  },
  title: {
    fontSize: 21,
    fontWeight: '600',
  },
  message: {
    fontSize: 15,
    fontWeight: '600',
  },
  image: {
    width: '100%',
    maxWidth: 375,
    maxHeight: 51.8,
    marginTop: 40,
    marginBottom: 40,
  },

}));

const SignUpThankYou = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Container className={classes.contentWrapper} maxWidth="sm">

        <Grid
          container
          direction="column"
          alignItems="center"
          justify="center"
        >
          <Typography className={classes.title} align="center">Thank you for registering</Typography>
          <LogoTreadMeal className={classes.image} />
          <Typography className={classes.message} align="center">
            An email has been sent to your email address
          </Typography>
          <Typography className={classes.message} align="center">
            Please check your mailbox and verify to activate
          </Typography>
        </Grid>
      </Container>

    </div>
  );
};

export default SignUpThankYou;
